<template>
  <section
    :id="ANCHORS.SAFE_DEAL"
    class="safe_deal"
  >
    <div class="osk-wrapper">
      <div class="title_block_sm">
        {{ $t('components.info.safeDeal.title') }}
      </div>

      <div
        class="section-subtitle"
        style="max-width: 340px"
      >
        {{ $t('components.info.safeDeal.text') }}
      </div>

      <div class="list_safe_deal_info">
        <ul>
          <li
            v-for="(step, i) in steps"
            :key="step.title"
            class="number_one"
          >
            <div class="number">
              {{ i + 1 }}
            </div>

            <div class="name_list">
              {{ step.title }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ANCHORS } from '~/components/info/anchors';

const { t } = useI18n();

const steps = [
  {
    title: t('components.info.safeDeal.step1.title'),
  },
  {
    title: t('components.info.safeDeal.step2.title'),
  },
  {
    title: t('components.info.safeDeal.step3.title'),
  },
  {
    title: t('components.info.safeDeal.step4.title'),
  },
  {
    title: t('components.info.safeDeal.step5.title'),
  },
];
</script>

<style scoped lang="scss">
section.safe_deal {
  padding: 80px 0 78px;
  border-top: 1px solid rgba(51, 51, 51, 0.1);
}

section.safe_deal.safe_deal_buyer {
  padding: 80px 0 56px;
}

section.safe_deal .section-subtitle {
  margin: 18px 0 0;
  text-align: left;
  max-width: 100%;
}

section.safe_deal .list_safe_deal_info {
  margin-top: 30px;
}

section.safe_deal .list_safe_deal_info ul {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

section.safe_deal .list_safe_deal_info ul li {
  position: relative;
  padding: 42px 20px 0 0;
  box-sizing: border-box;
}

section.safe_deal .list_safe_deal_info ul li.number_one {
  width: 23%;
}
section.safe_deal .list_safe_deal_info ul li.number_two {
  width: 28%;
}
section.safe_deal .list_safe_deal_info ul li.number_tree {
  width: 32%;
}
section.safe_deal .list_safe_deal_info ul li.number_four {
  width: 17%;
}

section.safe_deal .list_safe_deal_info ul li:last-child {
  padding-right: 0;
}

section.safe_deal .list_safe_deal_info ul li:last-child:before {
  display: none;
}

section.safe_deal .list_safe_deal_info ul li:before {
  content: "";
  position: absolute;
  top: 12px;
  left: 0px;
  background: #27AE60;
  width: 100%;
  height: 1px;
}

section.safe_deal .list_safe_deal_info ul li .number {
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  color: #ffffff;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  background: #27AE60;
  border-radius: 50%;
}

section.safe_deal .list_safe_deal_info ul li .name_list {
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}

@media only screen and (max-width: 1024px) {
  section.safe_deal {
    padding: 60px 0 61px;
  }

  section.safe_deal .list_safe_deal_info {
    margin-top: 37px;
  }

  section.safe_deal .list_safe_deal_info ul li {
    padding: 45px 32px 0 0;
  }

  section.safe_deal .list_safe_deal_info ul li.number_two {
    width: 24%;
  }

  section.safe_deal .list_safe_deal_info ul li.number_tree {
    width: 30%;
  }

  section.safe_deal .list_safe_deal_info ul li.number_four {
    width: 23%;
  }

  section.safe_deal .list_safe_deal_info ul li .name_list {
    font-size: 12px;
    line-height: 16px;
  }

  section.safe_deal.safe_deal_buyer {
    padding: 60px 0 47px;
  }
}

@media only screen and (max-width: 767px) {
  section.safe_deal {
    padding: 41px 0 40px;
  }

  section.safe_deal .section-subtitle {
    margin-top: 12px;
  }

  section.safe_deal .list_safe_deal_info {
    margin-top: 23px;
  }

  section.safe_deal .list_safe_deal_info ul {
    display: block;
  }

  section.safe_deal .list_safe_deal_info ul li {
    width: 100% !important;
    padding: 4px 0 37px 35px;
  }

  section.safe_deal .list_safe_deal_info ul li:last-child {
    padding-bottom: 0;
  }

  section.safe_deal .list_safe_deal_info ul li:before {
    left: 12px;
    top: 0;
    width: 1px;
    height: 100%;
  }

  section.safe_deal.safe_deal_buyer {
    padding: 41px 0 39px;
  }

  section.safe_deal.safe_deal_buyer .section-subtitle br {
    display: none;
  }
}
</style>
